var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-60,-388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 76,413.01367 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z",
    id: "path453599",
    style: {
      color: "#000000",
      fill: "#000000",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.1,
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 86,403.01367 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z",
    id: "path453581",
    style: {
      color: "#000000",
      fill: "#000000",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.1,
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76,403.01367 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z",
    id: "path453579",
    style: {
      color: "#000000",
      fill: "#000000",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.1,
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 66,403.01367 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z",
    id: "path453577",
    style: {
      color: "#000000",
      fill: "#000000",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.1,
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 82.458984,396.65234 a 1.0001,1.0001 0 0 0 -0.453125,0.0625 l -9.193359,3.53711 a 1.0001,1.0001 0 0 0 -0.574219,0.57422 l -3.535156,9.19141 a 1.0001,1.0001 0 0 0 1.291016,1.29297 l 9.193359,-3.53516 a 1.0001,1.0001 0 0 0 0.574219,-0.57422 l 3.535156,-9.19336 a 1.0001,1.0001 0 0 0 -0.837891,-1.35547 z m -1.83789,2.73828 -2.566406,6.67774 -6.675782,2.56641 2.566406,-6.67579 z",
    id: "path453571",
    style: {
      color: "#000000",
      fill: "#000000",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.1,
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76,393.01367 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z",
    id: "path453565",
    style: {
      color: "#000000",
      fill: "#000000",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.1,
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76,390.01367 c -7.720111,0 -14,6.27989 -14,14 0,7.72011 6.279889,14 14,14 7.720111,0 14,-6.27989 14,-14 0,-7.72011 -6.279889,-14 -14,-14 z m 0,2 c 6.639228,0 12,5.36078 12,12 0,6.63924 -5.360772,12 -12,12 -6.639228,0 -12,-5.36076 -12,-12 0,-6.63922 5.360772,-12 12,-12 z",
    id: "path453553",
    style: {
      color: "#000000",
      fill: "#000000",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.1,
      InkscapeStroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripster);
export default __webpack_public_path__ + "static/media/tripster.ef2cf1af45381580a80332df15be59ee.svg";
export { ForwardRef as ReactComponent };